import { render, staticRenderFns } from "./apprAppr.vue?vue&type=template&id=ca0dbd7e"
import script from "./apprAppr.vue?vue&type=script&lang=js"
export * from "./apprAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca0dbd7e')) {
      api.createRecord('ca0dbd7e', component.options)
    } else {
      api.reload('ca0dbd7e', component.options)
    }
    module.hot.accept("./apprAppr.vue?vue&type=template&id=ca0dbd7e", function () {
      api.rerender('ca0dbd7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/appr/doc/apprAppr.vue"
export default component.exports